import { render, staticRenderFns } from "./LayoutGuest.vue?vue&type=template&id=72f06b19&scoped=true&"
import script from "./LayoutGuest.vue?vue&type=script&lang=ts&"
export * from "./LayoutGuest.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutGuest.vue?vue&type=style&index=0&id=72f06b19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f06b19",
  null
  
)

export default component.exports